import React from 'react';
import styled from 'styled-components';
import { StyledVerticalDrawer } from 'components/Styled';

const StyledPaymentVerticalDrawer = styled(StyledVerticalDrawer)`
  &.alipayGlobalWeb {
    .ant-drawer-body {
      background-color: #00b1f7 !important;
    }
  }

  &.alipayGlobalWap {
    .ant-drawer-body {
      background-color: #fff !important;
    }
  }
`;

const RedirectPopup = props => {
  return (
    <StyledPaymentVerticalDrawer
      placement="bottom"
      visible={props.visible}
      width="100%"
      height="100%"
      className={props.paymentMethod}
      onClose={props.onClose}>
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
        {(() => {
          switch (props.paymentMethod) {
            case 'alipayGlobalWeb':
              return (
                <>
                  <div
                    style={{
                      fontSize: '20px',
                      fontWeight: 700,
                      backgroundColor: '#fff',
                      padding: '12px 0',
                      textAlign: 'center'
                    }}>
                    {props.t('payment.payment_method_alipayGlobalWeb')}
                  </div>
                  <div
                    style={{
                      fontSize: '16px',
                      fontWeight: 700,
                      color: '#fff',
                      padding: '20px 0 25px',
                      textAlign: 'center'
                    }}>
                    {props.t('payment.scan_to_pay')}
                  </div>
                  <iframe
                    scrolling="no"
                    style={{
                      border: 0,
                      height: '240px',
                      width: '240px',
                      display: 'block',
                      margin: '0 auto',
                      padding: '20px',
                      backgroundColor: '#fff'
                    }}
                    src={props.redirectUrl}
                  />
                </>
              );
            case 'alipayGlobalWap':
              return (
                <>
                  <div
                    style={{
                      fontSize: '20px',
                      fontWeight: 700,
                      backgroundColor: '#fff',
                      padding: '12px 0',
                      textAlign: 'center'
                    }}>
                    {props.t('payment.payment_method_alipayGlobalWeb')}
                  </div>
                  <iframe
                    style={{
                      border: 0,
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      flex: '1 1 auto',
                      backgroundColor: '#fff'
                    }}
                    src={props.redirectUrl}
                  />
                </>
              );
          }
        })()}
      </div>
    </StyledPaymentVerticalDrawer>
  );
};

export default RedirectPopup;
